// extracted by mini-css-extract-plugin
export default {"button":"BackToTopButton_button__eFunQ","icon":"BackToTopButton_icon__6wzER"};